import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { Button as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Delete } from '../../images/icons/delete.svg';

interface IProps extends StyledComponentProps {
    onClick: (evt: any) => any;
    disabled?: boolean;
    text: string;
}

const DeleteButton = React.forwardRef((props: IProps, ref: any) => {
    // const DeleteButton = (props: IProps) => {
    return <MuiButton
        innerRef={ref} 
        disabled={props.disabled}
        className={props.classes.btnRootWithIcon}
        onClick={props.onClick}
        variant="contained">
        <div className={props.classes.withLeftIcon}>
            <Delete className={props.classes.buttonItemIcon} />
            {props.text}
        </div>
    </MuiButton>
});


export default withStyles(styles)(DeleteButton)